export default __webpack_public_path__ + "static/media/search.bcd7e19e.svg";